/**
 * Sports offered in the Training app.
 * Each sport has its own page under /training/<id> — keep them separate.
 * Add a new key here when introducing another sport.
 */

export const TRAINING_SPORTS = {
  soccer: {
    id: 'soccer',
    name: 'Soccer',
    shortLabel: 'Soccer',
    href: '/training/soccer',
    trackerHref: '/training/soccer/tracker',
    tagline: 'Strength, stamina, and skill work built around match weeks.',
    summary:
      'Weekly plans that mix gym strength, pitch stamina, and ball skill so you stay match-ready without burning out.',
    highlights: ['Strength sessions', 'Stamina & intervals', 'Ball skill work', 'Match-week taper'],
    trainings: [
      {
        id: 'BEGINNER',
        name: 'Beginner Soccer Fitness',
        level: 'Beginner',
        description: 'Build a base with easy strength, stamina, and ball work.',
      },
      {
        id: 'INTERMEDIATE',
        name: 'Intermediate Match Ready',
        level: 'Intermediate',
        description: 'Harder intervals and skill volume for regular players.',
      },
      {
        id: 'MATCH_WEEK',
        name: 'Match-Week Taper',
        level: 'Match week',
        description: 'Stay sharp while protecting legs before game day.',
      },
    ],
    trackerAvailable: true,
    ctaLabel: 'Open soccer tracker',
  },
  running: {
    id: 'running',
    name: 'Running',
    shortLabel: 'Running',
    href: '/training/running',
    trackerHref: null,
    tagline: 'Mileage, hills, tempo, and race-week sharpening.',
    summary:
      'Running plans that balance easy aerobic miles with hills, tempo, and race-week sharpening—so you build endurance without stacking hard days.',
    highlights: ['Easy aerobic miles', 'Hill strength', 'Tempo & intervals', 'Race-week sharpening'],
    trainings: [
      {
        id: 'RUN_BASE',
        name: 'Base Building',
        level: 'Beginner–intermediate',
        description: 'Steady easy miles and light strides to grow aerobic fitness.',
      },
      {
        id: 'RUN_HILLS',
        name: 'Hill Strength',
        level: 'Intermediate',
        description: 'Repeats and strength work that transfer to rolling routes.',
      },
      {
        id: 'RUN_TEMPO',
        name: 'Tempo & Threshold',
        level: 'Intermediate',
        description: 'Controlled hard efforts to raise race pace comfort.',
      },
      {
        id: 'RUN_RACE_WEEK',
        name: 'Race-Week Sharpen',
        level: 'Race week',
        description: 'Shorter, snappy sessions so you arrive fresh on race day.',
      },
    ],
    trackerAvailable: false,
    ctaLabel: 'Join to get notified',
  },
};

/** Old training URLs still resolve to the current sport pages. */
export const TRAINING_SPORT_ALIASES = {
  'cross-country': 'running',
  xc: 'running',
};

export const TRAINING_SPORT_LIST = Object.values(TRAINING_SPORTS);

export function getTrainingSport(sportId) {
  if (!sportId) return null;
  const key = TRAINING_SPORT_ALIASES[sportId] || sportId;
  return TRAINING_SPORTS[key] || null;
}
